/**
 * Where the connect flow is.
 *
 * Ordered as the flow runs, because the progress bar reads its position out of
 * this order rather than carrying a second list that could disagree with it.
 *
 * Handoff is a step of its own rather than a line on the picker. It is the last
 * thing seen before the browser leaves for somebody else's site, and being told
 * where you are about to go — and what is and is not being asked for there — is
 * the difference between a redirect and a hijack.
 */
export enum ImportModalStep {
  /** What this does and what it will read, before any app is named. */
  Intro = "intro",
  /** Which app. */
  Provider = "provider",
  /** Where you are about to be sent, and what for. */
  Handoff = "handoff",
  /** Which rides. */
  Sessions = "sessions",
  /** What was reported, and what was not. */
  Done = "done",
}

/**
 * The steps in the order the flow runs them, for the progress bar.
 *
 * Done is absent on purpose: the bar is full by the time it is reached, and a
 * fifth division would make every earlier step look shorter than it is.
 */
export const IMPORT_FLOW_STEP_ORDER: readonly ImportModalStep[] = [
  ImportModalStep.Intro,
  ImportModalStep.Provider,
  ImportModalStep.Handoff,
  ImportModalStep.Sessions,
];
